import { Form, Checkbox, Row, Col, DatePicker } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';
import SelectIbsZfmPresumedCreditType from '../SelectIBSPresumedCreditType';

interface Props {
  prefixPath?: string[];
}

export default function IbsZfmPresumedCreditFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enablePresumedCreditIbsZfm = Form.useWatch(
    'enablePresumedCreditIbsZfm',
    form,
  );

  return (
    <>
      <div>
        <Form.Item name="enablePresumedCreditIbsZfm" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo Apropriação de CP de IBS Sobre o Saldo Devedor na ZFM
          </Checkbox>
        </Form.Item>
      </div>

      <SectionCard
        visible={enablePresumedCreditIbsZfm}
        style={{ marginBottom: 24 }}
        title="Apropriação de CP de IBS Sobre o Saldo Devedor na ZFM"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Período de Apuração (MM-AAAA)"
              name={[...prefixPath, 'ibsZfmAssessmentPeriod']}
            >
              <DatePicker.MonthPicker
                format="MM/YYYY"
                style={{ width: '100%' }}
                placeholder=""
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Classificação de Apropriação CP"
              name={[...prefixPath, 'ibsZfmPresumedCreditType']}
            >
              <SelectIbsZfmPresumedCreditType allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor CP Sobre o Saldo Devedor"
              name={[...prefixPath, 'ibsZfmPresumedCreditValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>
    </>
  );
}
